import { CampaignUrl, DashboardUrl } from "@common";
import { AppState, CampaignInfo, createOrUpdateCampaignAction, changeCreateUserModalStatusAction } from "@store";
import * as cn from "classnames";
import { History, Location } from "history";
import { FETCH_STATE_SUCCESS } from "rd-redux-http";
import * as React from "react";
import { connect, Dispatch } from "react-redux";
import {
    SidePanelIconCancelOn,
    SidePanelIconSaveOn,
    SidePanelIconSaveOff,
    SidePanelIconCancelOff,
    UserPlusSolid,
    SidePanelIconAddOn,
    SidePanelIconAddOff
} from "../icons";
import "./AppControlHeader.css";
import { StaticReportDownload } from "./StaticReportDownload";
import { SvgIcon } from "./SvgIcon";

export interface AppControlHeaderComponentProps {
    className?: string;
    selectedPage: string;
    selectedCampaignId?: string;
    canEditOrDeleteCampaign: boolean;
    isMobileScreen: boolean;
    isAsideContentOpen: boolean;
    clientId: string;
    history: History;
    location: Location;
    editCamapignId: string | undefined;
    onLinkToCampaignEditPage: (clientId: string, campaignId: string) => void;
    onLinkToNewCampaignPage: (clientId: string) => void;
    onDelete: (campaignId: string, clientId: string) => void;
    onSubmit: (campaignId: string, clientId: string) => void;
    onCancel: () => void;
    updateAsideContentState?: () => void;
    onOpenCreateUserModal?: () => void;
}

export class AppControlHeaderComponent extends React.Component<AppControlHeaderComponentProps, any> {
    constructor(props: AppControlHeaderComponentProps) {
        super(props);
        this.state = {
            isHovered: {
                IconSave: false,
                IconCancel: false,
                IconAdd: false
            }
        };
    }

    hoverIcon(icon: string) {
        this.setState({
            ...this.state,
            isHovered: {
                ...this.state.isHovered,
                [icon]: true
            }
        });
    }

    unHoverIcon(icon: string) {
        this.setState({
            ...this.state,
            isHovered: {
                ...this.state.isHovered,
                [icon]: false
            }
        });
    }

    chooseControls() {
        const { selectedPage } = this.props;
        switch (selectedPage) {
            case "campaign":
                return this.renderCampaignControsl();
            case "users":
                return this.renderUsersControls();
            // case "dashboard":
            //     return this.renderDashboardControls();
            case "reports":
                return this.renderReportsControls();
            default:
                return null;
        }
    }

    renderCampaignControsl() {
        const { clientId, editCamapignId, onSubmit, onCancel } = this.props;
        const { IconSave, IconCancel } = this.state.isHovered;
        return (
            <>
                <span
                    className="control-icon"
                    onClick={() => onSubmit(clientId, editCamapignId)}
                    onMouseOver={e => this.hoverIcon("IconSave")}
                    onMouseLeave={e => this.unHoverIcon("IconSave")}
                >
                    <SvgIcon svg={IconSave ? SidePanelIconSaveOn : SidePanelIconSaveOff} />
                </span>
                <span
                    className="control-icon"
                    onClick={onCancel}
                    onMouseOver={e => this.hoverIcon("IconCancel")}
                    onMouseLeave={e => this.unHoverIcon("IconCancel")}
                >
                    <SvgIcon svg={IconCancel ? SidePanelIconCancelOn : SidePanelIconCancelOff} />
                </span>
            </>
        );
    }

    renderUsersControls() {
        const { onOpenCreateUserModal } = this.props;
        return (
            <span onClick={onOpenCreateUserModal}>
                <SvgIcon className="users__add-user-btn" svg={UserPlusSolid} title="Add user" />
            </span>
        );
    }

    renderDashboardControls() {
        const { clientId, onLinkToNewCampaignPage } = this.props;
        const { IconAdd } = this.state.isHovered;
        return (
            <>
                <span
                    className="control-icon bad-control-svg"
                    onClick={e => onLinkToNewCampaignPage(clientId)}
                    onMouseOver={e => this.hoverIcon("IconAdd")}
                    onMouseLeave={e => this.unHoverIcon("IconAdd")}
                >
                    <SvgIcon svg={IconAdd ? SidePanelIconAddOn : SidePanelIconAddOff} />
                </span>
            </>
        );
    }

    renderReportsControls() {
        return (
            <>
                <span className="control-icon">
                    <StaticReportDownload />
                </span>
            </>
        );
    }

    renderMobilesControls() {
        const {
            updateAsideContentState,

            isAsideContentOpen
        } = this.props;
        return (
            <span className="show-info-btn" onClick={e => updateAsideContentState()}>
                {isAsideContentOpen ? "Close info" : "Show info"}
            </span>
        );
    }

    render() {
        const { isMobileScreen } = this.props;

        return (
            <div className={cn(this.props.className, "control-wrapper")}>
                {this.chooseControls()}
                {isMobileScreen && this.renderMobilesControls()}
            </div>
        );
    }
}

export interface AppControlHeaderProps {
    className?: string;
    selectedPage: string;
    history?: History;
    location?: Location;
    clientId: string;
    isMobileScreen?: boolean;
    isAsideContentOpen?: boolean;
    updateAsideContentState?: () => void;
}

export const AppControlHeader = connect(
    (state: AppState, ownProps: AppControlHeaderProps): Partial<AppControlHeaderComponentProps> => {
        let canEditOrDeleteCampaign: boolean = false;
        if (state.campaignList.campaigns.fetchState === FETCH_STATE_SUCCESS) {
            const selectedCampaign = state.campaignList.campaigns.data.filter(
                (campaign: CampaignInfo) => campaign.campaignId === state.campaignList.selectedCampaignId
            )[0];
            canEditOrDeleteCampaign = selectedCampaign && selectedCampaign.status === "draft" ? true : false;
        }
        return {
            history: ownProps && ownProps.history,
            location: ownProps && ownProps.history && ownProps.history.location,
            selectedCampaignId: state.campaignList.selectedCampaignId,
            clientId: ownProps.clientId,
            canEditOrDeleteCampaign,
            editCamapignId:
                state.campaignState.editingCampaign.fetchState === FETCH_STATE_SUCCESS
                    ? state.campaignState.editingCampaign.data.result.campaignId
                    : undefined
        };
    },
    dispatch => (dispatch: Dispatch, ownProps: AppControlHeaderProps): Partial<AppControlHeaderComponentProps> => {
        return {
            onLinkToNewCampaignPage: (clientId: string) => {
                ownProps.history.push(CampaignUrl.format({ clientId: clientId }));
            },
            onSubmit: (clientId: string, editCamapignId: string) => {
                const mode = editCamapignId ? "update" : "create";
                dispatch(createOrUpdateCampaignAction({ clientId: clientId, campaignId: editCamapignId, mode: mode }));
            },
            onCancel: () => {
                ownProps.history.push(DashboardUrl.format({ clientId: ownProps.clientId }));
            },
            onOpenCreateUserModal: () => {
                dispatch(changeCreateUserModalStatusAction({ isOpen: true }));
            }
        };
    }
)(AppControlHeaderComponent);
